export const zIndices = {
    inlineOverlay: 10,
};
